/**
 * Página mostrada cuando el usuario accede a una URL antigua dada de baja
 * (ej: app.food.smarty.lat, admin.food.smarty.lat). No se puede acceder: solo se informa
 * que la dirección fue dada de baja.
 */

import { Box, BlockStack, Text } from '@/lib/polaris';

export default function DeprecatedUrlPage() {
  return (
    <Box
      minHeight="100vh"
      padding="800"
      background="bg-fill"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box maxWidth="400px">
        <BlockStack gap="300">
          <Text as="h1" variant="headingLg">
            Dirección dada de baja
          </Text>
          <Text as="p" variant="bodyMd" tone="subdued">
            Esta URL ya no está en uso. No es posible acceder desde aquí.
          </Text>
        </BlockStack>
      </Box>
    </Box>
  );
}
